module.exports = __webpack_public_path__ + "img/emptyState.2d8ad6d8.svg";